const CREAR = 1
const ELIMINAR = 2
const MODIFICAR = 3
const CONSULTAR = 4

export default {
  CREAR: CREAR,
  ELIMINAR: ELIMINAR,
  MODIFICAR: MODIFICAR,
  CONSULTAR: CONSULTAR
}
